var path = 'app/components/common/navbarTop/navbarTop.html';
var html = "<nav class=\"navbar navbar-static-top\" role=\"navigation\" style=\"margin-bottom: 0\"><div class=\"navbar-header\"><a class=\"navbar-minimalize minimalize-styl-2 btn btn-primary\" href=\"#\"><i class=\"fa fa-bars\"></i></a><form role=\"search\" class=\"navbar-form-custom\" ng-submit=\"vm.submit()\"><div class=\"form-group\"><input ng-model=\"vm.searchValue\" type=\"text\" placeholder=\"{{vm.searchCaption}}\" class=\"form-control\" name=\"top-search\" id=\"top-search\"></div></form></div><ul class=\"nav navbar-top-links navbar-right\"><li><a ui-sref=\"login\"><i class=\"fa fa-sign-out\"></i> Odjava</a></li></ul></nav>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/components/common/navbarTop/navbarTop.html
// module id = 67
// module chunks = 0